module.exports = __webpack_public_path__ + "static/img/kefu_online.e11f3971.png";